import { cva } from '@/styled-system/css';

export const propertyCardDataAreaRecipe = cva({
  base: {
    'color': 'text.neutral',

    '& address': {
      fontStyle: 'normal',
    },
  },
  variants: {
    dataType: {
      dataArea1: {
        gridArea: 'dataArea1',
      },
      dataArea2: {
        gridArea: 'dataArea2',
        textStyle: 'body-sm',
      },
      dataArea3: {
        gridArea: 'dataArea3',
        textStyle: 'body-sm',
      },
      dataArea4: {
        gridArea: 'dataArea4',
        textStyle: 'body-sm',
      },
      dataArea5: {
        color: 'text.subtle',
        gridArea: 'dataArea5',
        textStyle: 'fineprint',
      },
    },
    appearance: {
      large: {},
      small: {},
      horizontal: {},
    },
    loading: {
      true: {
        backgroundColor: 'bg.softer',
        backgroundImage:
          'linear-gradient(to right, {colors.bg.softer}, {colors.bg.softest}, {colors.bg.softer})',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '{386px}',
        lineHeight: '1',

        _motionReduce: {
          animation: 'none',
        },
        _motionSafe: {
          animation: '1500ms shimmer infinite',
        },
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      appearance: 'large',
      dataType: 'dataArea1',
      css: {
        textStyle: 'heading-xs',
      },
    },
    {
      appearance: 'small',
      dataType: 'dataArea1',
      css: {
        textStyle: 'body-bold',
      },
    },
    {
      appearance: 'horizontal',
      dataType: 'dataArea1',
      css: {
        textStyle: 'heading-xs',
      },
    },
    {
      dataType: 'dataArea1',
      loading: true,
      css: {
        inlineSize: '75%',
      },
    },
    {
      dataType: 'dataArea2',
      loading: true,
      css: {
        inlineSize: '95%',
      },
    },
    {
      dataType: 'dataArea3',
      loading: true,
      css: {
        inlineSize: '85%',
      },
    },
    {
      appearance: 'large',
      loading: true,
      css: {
        // Use `marginBlockEnd` instead of `rowGap`. Because `DataWrapper` uses `gridTemplateAreas`,
        // there are row placeholders that will render a gap whether those data areas are in the DOM
        // or not.
        marginBlockEnd: 'tighter',
      },
    },
    {
      appearance: 'large',
      loading: false,
      css: {
        marginBlockEnd: 'PropertyCard.DataWrapper.large.gap.between-dataItems.default',
      },
    },
    {
      appearance: 'small',
      loading: true,
      css: {
        marginBlockEnd: 'tighter',
      },
    },
    {
      appearance: 'small',
      loading: false,
      css: {
        marginBlockEnd: 'PropertyCard.DataWrapper.small.gap.between-dataItems.default',
      },
    },
    {
      appearance: 'horizontal',
      loading: true,
      css: {
        marginBlockEnd: 'tighter',
      },
    },
    {
      appearance: 'horizontal',
      loading: false,
      css: {
        marginBlockEnd: 'PropertyCard.DataWrapper.horizontal.gap.between-dataItems.default',
      },
    },
  ],
});
